"use client";

import * as React from "react";
import * as TogglePrimitive from "@radix-ui/react-toggle";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@/lib/utils";

const toggleVariants = cva(
    "setu:inline-flex setu:items-center setu:justify-center setu:gap-2 setu:rounded-md setu:text-sm setu:font-medium setu:hover:bg-muted setu:hover:text-muted-foreground setu:disabled:pointer-events-none setu:disabled:opacity-50 setu:data-[state=on]:bg-accent setu:data-[state=on]:text-accent-foreground setu:[&_svg]:pointer-events-none setu:[&_svg:not([class*='size-'])]:size-4 setu:[&_svg]:shrink-0 setu:focus-visible:!border-ring setu:focus-visible:ring-ring/50 setu:focus-visible:ring-[3px] setu:outline-none setu:transition-[color,box-shadow] setu:aria-invalid:ring-destructive/20 dark:setu:aria-invalid:ring-destructive/40 setu:aria-invalid:!border-destructive setu:whitespace-nowrap",
    {
        variants: {
            variant: {
                default: "bg-transparent",
                outline:
                    "setu:!border setu:!border-input setu:bg-transparent setu:shadow-xs setu:hover:bg-accent setu:hover:text-accent-foreground",
            },
            size: {
                default: "setu:h-9 setu:px-2 setu:min-w-9",
                sm: "setu:h-8 setu:px-1.5 setu:min-w-8",
                lg: "setu:h-10 setu:px-2.5 setu:min-w-10",
            },
        },
        defaultVariants: {
            variant: "default",
            size: "default",
        },
    }
);

function Toggle({
    className,
    variant,
    size,
    ...props
}: React.ComponentProps<typeof TogglePrimitive.Root> & VariantProps<typeof toggleVariants>) {
    return (
        <TogglePrimitive.Root
            data-slot="toggle"
            className={cn(toggleVariants({ variant, size, className }))}
            {...props}
        />
    );
}

export { Toggle, toggleVariants };
